import React, { useState, useEffect } from 'react';
import { FaWallet, FaTwitter, FaGithub, FaDiscord } from "react-icons/fa";
import { RiTelegramLine } from "react-icons/ri";

const PassportCard = ({ passport, verifications = {} }) => {
  const [rotateY, setRotateY] = useState(0);
  const [rotateX, setRotateX] = useState(0);
  const [elevation, setElevation] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);
  

  useEffect(() => {
   
    const styleElement = document.createElement('style');
    styleElement.textContent = `
      .passport-content::-webkit-scrollbar {
        display: none;
      }
    `;
    document.head.appendChild(styleElement);
    

    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);
  
 
  const formatAddress = (address) => {
    if (!address) return '';
    return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
  };
  

  const handleMouseMove = (e) => {
    if (!isHovering || isFlipped) return;
    
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const mouseX = e.clientX;
    const mouseY = e.clientY;
    
   
    const rotateYValue = ((mouseX - centerX) / (rect.width / 2)) * 10;
    const rotateXValue = ((centerY - mouseY) / (rect.height / 2)) * 10;
    
    setRotateY(rotateYValue);
    setRotateX(rotateXValue);
  };

  const getPlatformIcon = (platform) => {
    switch(platform) {
      case 'twitter':
        return <FaTwitter className={`platform-icon-svg ${platform}`} />;
      case 'discord':
        return <FaDiscord className={`platform-icon-svg ${platform}`} />;
      case 'github':
        return <FaGithub className={`platform-icon-svg ${platform}`} />;
      case 'solana':
        return <FaWallet className={`platform-icon-svg ${platform}`} />;
      default:
        return null;
    }
  };

  const handleMouseEnter = () => {
    if (!isFlipped) {
      setIsHovering(true);
      setElevation(20);
    }
  };
  
  const handleMouseLeave = () => {
    if (!isFlipped) {
      setIsHovering(false);
      setRotateY(0);
      setRotateX(0);
      setElevation(0);
    }
  };
  

  const handleCardClick = () => {
    setIsFlipped(!isFlipped);
    
    if (!isFlipped) {
 
      setRotateY(180);
      setRotateX(0);
    } else {
  
      setRotateY(0);
      setRotateX(0);
    }
  };
  

  const allPlatforms = ['twitter', 'github','solana','discord'];
  

  const verifiedPlatforms = Object.keys(verifications);
  
  return (
    <div 
      className={`passport-card-container ${isFlipped ? 'flipped' : ''}`}
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleCardClick}
      style={{
        transform: `perspective(1000px) rotateY(${isFlipped ? 180 : rotateY}deg) rotateX(${rotateX}deg) translateZ(${elevation}px)`,
      }}
    >
    
      <div className="passport-card-inner">
      
        <div className="passport-cover">
          <div className="passport-emblem"></div>
          <h3 className="passport-title gradient-text">Social Passport</h3>
      
          {passport?.category && (
            <div style={{
              background: 'rgba(124, 77, 255, 0.15)',
              padding: '0.2rem 0.7rem',
              borderRadius: '4px',
              fontFamily: 'var(--font-family-mono)',
              fontSize: '0.6rem',
              textTransform: 'capitalize',
              marginTop: '0.5rem',
              marginBottom: '0.5rem',
              color: 'var(--color-primary)',
              border: '1px solid rgba(124, 77, 255, 0.3)'
            }}>
              {passport.category}
            </div>
          )}
          <p className="passport-subtitle">Digital Identity Verification</p>
          
          <div className="passport-footer">
            <span className="passport-address">ID: {passport?.id || '0'}</span>
            <span className="passport-address">{formatAddress(passport?.owner || '')}</span>
          </div>
        </div>
        

        <div className="passport-content" style={{ overflowY: 'scroll', scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
          <div className="passport-content-header">
            <h4 className="passport-content-title">Verified Accounts</h4>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
              <span className="passport-created-date">
                Issued: {passport?.createdAt ? new Date(passport.createdAt).toISOString().split('T')[0] : 'N/A'}
              </span>
            </div>
          </div>
          
          <div className="verification-stamps">
            {allPlatforms.map(platform => {
              const isVerified = verifiedPlatforms.includes(platform);
              const verificationData = isVerified ? verifications[platform] : null;
              
              return (
                <div key={platform} className={`verification-stamp ${isVerified ? 'verified' : 'not-verified'}`}>
                  <div className="passport-icon-container">
                    {getPlatformIcon(platform)}
                  </div>
<div className="stamp-details">
  <span className="stamp-platform">{platform.charAt(0).toUpperCase() + platform.slice(1)}</span>
  {isVerified ? (
    <>
      <span className="stamp-id" style={{
        fontSize: platform === 'solana' ? '0.7rem' : 'inherit',
        fontFamily: platform === 'solana' ? 'monospace' : 'inherit',
        letterSpacing: platform === 'solana' ? '0.5px' : 'normal'
      }}>
        {platform === 'solana' 
          ? `${verificationData.identifier.substring(0, 8)}...${verificationData.identifier.substring(verificationData.identifier.length - 8)}`
          : verificationData.identifier
        }
      </span>
      <span className="stamp-date">
        {new Date(verificationData.verifiedAt).toISOString().split('T')[0]}
      </span>
      <div className="stamp-verified-badge">VERIFIED</div>
    </>
  ) : (
    <span className="stamp-not-verified">Not Verified</span>
  )}
</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      

      <div className="passport-shimmer"></div>
    </div>
  );
};

export default PassportCard;